import React from 'react'
import { OVOFootnoteProvider } from 'src/ui-kit/components/OVOFootnote/OVOFootnote'

const AppWrapper = ({ children }: { children: React.ReactNode }) => {
  return <OVOFootnoteProvider markerType="number">{children}</OVOFootnoteProvider>
}

export default AppWrapper
